import { useAuth } from "./auth";
import { getUrl } from "../getUrl";

export enum TaskmapProduct {
  BLOSSOM = "BLOSSOM",
  VIGOUR = "VIGOUR",
}

export type Terminal = {
  type: string;
};

export type MachineParameters = {
  type: string;
};

export type TaskmapParameters = {
  cutoff_low: string;
  cutoff_high: string;
  rate_low: number;
  rate_high: number;
  machine_parameters: MachineParameters;
};

type RateZone = {
  lower: number;
  upper: number;
  rate: number;
};

export type VariableTaskmapParamaters = {
  zones: RateZone[];
};

export type Properties = {
  terminal: Terminal;
  parameters: TaskmapParameters | VariableTaskmapParamaters;
};

export async function getTaskmap(
  properties: Properties,
  resultSetId: string | undefined,
): Promise<Response | null> {
  const token = await useAuth.getState().getToken();
  if (!token) {
    return null;
  }
  return await fetch(getUrl(`/v1/result_set/${resultSetId}/task_map`), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(properties),
  });
}

export async function mergeTaskmaps(
  customerId: number | string,
  taskmapIds: string[],
): Promise<Response | null> {
  const token = await useAuth.getState().getToken();
  if (!token) {
    return null;
  }
  return await fetch(getUrl(`/v1/customer/${customerId}/merged_task_map`), {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ task_map_ids: taskmapIds }),
  });
}
